import React from 'react'

export default function NotFound() {
  return (
    <div>Under construction</div>
  )
}
